import { createContext } from "react";
import { Token } from "../../interfaces/jwt.interface";

export type AuthContextType = {
  login: (auth: Token) => void;
  logout: () => void;
} & Partial<Token>;

export default createContext<AuthContextType>({} as AuthContextType);
